angular.module('rjmNg.api').factory("AgeDefinition", [
  'BaseDefinition'
  (BaseDefinition) ->

    class AgeDefinition extends BaseDefinition

      @definition: 'age'
      @category: 'sameTable'
      @arg: 'column'
      @subtypes: [
          symbol: 'AGE'
          description: 'The number of seconds between now and some DATETIME value.'
          typeFilter: [
            'inst'
          ]
      ]
      @filtersSupported: false

      @fromColumn: (structure, column) ->
        result = super structure, column, @definition

        result.properties = {}

        columnId = column.properties.source_column_id
        tableId = structure.columns[columnId].table_id

        result.properties.source_column =
          column: column.properties.source_column_id
          table: tableId

        return result

      @toColumn: (structure, table, field) ->

        result = super structure, table, field
        result.field_type =  'value_seconds'
        result.old_data_type = 'BIGINT'
        angular.extend(result.properties,
          derivative_type: 'age'
          source_column_id: field.properties.source_column.column
        )

        return result

      @validateField: (column) ->
        super?.validateField(column)
        unless column.properties.source_column?.column? and column.properties.source_column.column isnt 0
          throw "You need to select an input column."
  ]
)
